import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

const styles = (theme) => ({
  dialogContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: `${theme.spacing.unit * 3}px`,
  },
  dialogTitle: {
    textAlign: 'center',
  },
  iframe: {
    flex: 1,
    width: '100%',
    height: '100%',
    display: 'block',
    overflow: 'hidden',
  },
});

/**
 * Generate an HTML page that auto-submits a POST form to the ACS URL
 * with the PAReq and MD parameters for 3DS challenge.
 * The ACS will redirect to our callback URL after the challenge.
 */
const build3DSChallengeHtml = ({ actionUrl, pareq, pareqFieldName, pareqFieldValue, md, mdFieldName, mdFieldValue, termUrl }) => {
  const paresFieldName = pareqFieldName || 'PaReq';
  const paresValue = pareq || pareqFieldValue || '';
  const mdName = mdFieldName || 'MD';
  const mdValue = md || mdFieldValue || '';

  return `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"><title>3DS Challenge</title></head>
<body onload="document.getElementById('threedsForm').submit()">
  <form id="threedsForm" method="POST" action="${actionUrl}">
    <input type="hidden" name="${paresFieldName}" value="${encodeURIComponent(paresValue)}" />
    <input type="hidden" name="${mdName}" value="${encodeURIComponent(mdValue)}" />
    <input type="hidden" name="TermUrl" value="${termUrl}" />
  </form>
</body>
</html>`;
};

class DialogWallet3DS extends React.Component {
  static defaultProps = {
    open: false,
    threeDSData: null,
    callbackUrl: null,
    onClose: () => {},
    onComplete: () => {},
  };

  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = (event) => {
    if (!event.data || event.data.type !== 'wallet3DSResponse') return;

    const { pares, md } = event.data;

    if (pares) {
      this.props.onComplete({ pares, md });
    } else {
      this.props.onClose();
    }
  };

  getIframeContent() {
    const { threeDSData, callbackUrl } = this.props;

    if (!threeDSData) return '';

    return build3DSChallengeHtml({
      actionUrl: threeDSData.actionUrl,
      pareq: threeDSData.pareq,
      pareqFieldName: threeDSData.pareqFieldName,
      pareqFieldValue: threeDSData.pareqFieldValue,
      md: threeDSData.md,
      mdFieldName: threeDSData.mdFieldName,
      mdFieldValue: threeDSData.mdFieldValue,
      termUrl: callbackUrl || `${window.location.origin}/api/rest/payline/wallet/3ds/callback`,
    });
  }

  render() {
    const { open, onClose, classes } = this.props;

    const iframeContent = this.getIframeContent();

    return (
      <Dialog open={open} fullScreen={true} disableBackdropClick={true} disableEscapeKeyDown={true}>
        <DialogTitle className={classes.dialogTitle}>
          {"Demande d'authentification 3D Secure aupr\u00e8s de votre banque..."}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <iframe
            ref={this.iframeRef}
            height='100%'
            width='100%'
            frameBorder='0'
            title='wallet3ds'
            className={classes.iframe}
            srcDoc={iframeContent}
          />
        </DialogContent>
        <DialogActions>
          <Button color='secondary' onClick={onClose} variant='outlined'>
            {'Annuler'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DialogWallet3DS);
